class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    let arraySections = []
    if (window.innerWidth > 920 && document.querySelector('.header-without-sidebars')) {
      arraySections = [
        {
          id: 'main-cart',
          section: document.getElementById('main-cart').dataset.id,
          selector: 'shopify-section',
        },
        {
          id: 'cart-icon-bubble-header',
          section: 'header',
          selector: '.cart-icon-bubble-count'
        },
        {
          id: 'cart-icon-bubble-menu-drawer',
          section: 'menu-drawer',
          selector: '.cart-icon-bubble-count'
        },
        {
          id: 'cart-icon-bubble-secondary-sidebar',
          section: 'secondary-sidebar',
          selector: '.cart-icon-bubble-count'
        },
        {
          id: 'cart-icon-bubble-main-sidebar',
          section: 'main-sidebar',
          selector: '.cart-icon-bubble-count'
        }
      ];
    } else if (window.innerWidth > 920 && document.querySelector('.secondary-header-section')) {
      arraySections = [
        {
          id: 'main-cart',
          section: document.getElementById('main-cart').dataset.id,
          selector: 'shopify-section',
        },
        {
          id: 'cart-icon-bubble-secondary-header',
          section: 'secondary-header',
          selector: '.cart-icon-bubble-count'
        },
        {
          id: 'cart-icon-bubble-menu-drawer',
          section: 'menu-drawer',
          selector: '.cart-icon-bubble-count'
        },
        {
          id: 'cart-icon-bubble-secondary-sidebar',
          section: 'secondary-sidebar',
          selector: '.cart-icon-bubble-count'
        },
        {
          id: 'cart-icon-bubble-main-sidebar',
          section: 'main-sidebar',
          selector: '.cart-icon-bubble-count'
        }
      ];
    } else {
      arraySections = [
        {
          id: 'main-cart',
          section: document.getElementById('main-cart').dataset.id,
          selector: 'shopify-section',
        },
        {
          id: 'cart-icon-bubble-menu-drawer',
          section: 'menu-drawer',
          selector: '.cart-icon-bubble-count'
        },
        {
          id: 'cart-icon-bubble-mobile-header',
          section: 'mobile-header',
          selector: '.cart-icon-bubble-count'
        }
      ];
    }
    return arraySections
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          if (document.querySelectorAll(`#${section.id}`)) {
            const elementsToCart = document.querySelectorAll(`#${section.id}`);
            Array.from(elementsToCart).forEach(element => {
              element.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], `#${section.id}`);
            })
          }
        }));

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          typeof updatedValue === 'undefined' ? message = window.cartStrings.error : message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
        this.disableLoading(line);

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: state
          }
        }))

      }).catch(() => {
        this.querySelectorAll('.loading-overlay__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) {
          errors.textContent = window.cartStrings.error;
          errors.style.marginTop = '16px'
        }
      }).finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);
      setTimeout(() => cartStatus.setAttribute('aria-hidden', true), 1e3);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    let arraySections = []
    if (window.innerWidth > 920 && document.querySelector('.header-without-sidebars')) {
      arraySections = [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner'
        },
        {
          id: 'cart-icon-bubble-header',
          section: 'header',
          selector: '.cart-icon-bubble-count'
        },
        {
          id: 'cart-icon-bubble-menu-drawer',
          section: 'menu-drawer',
          selector: '.cart-icon-bubble-count'
        },
        {
          id: 'cart-icon-bubble-secondary-sidebar',
          section: 'secondary-sidebar',
          selector: '.cart-icon-bubble-count'
        },
        {
          id: 'cart-icon-bubble-main-sidebar',
          section: 'main-sidebar',
          selector: '.cart-icon-bubble-count'
        }
      ];
    } else if (window.innerWidth > 920 && document.querySelector('.secondary-header-section')) {
      arraySections = [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner'
        },
        {
          id: 'cart-icon-bubble-secondary-header',
          section: 'secondary-header',
          selector: '.cart-icon-bubble-count'
        },
        {
          id: 'cart-icon-bubble-menu-drawer',
          section: 'menu-drawer',
          selector: '.cart-icon-bubble-count'
        },
        {
          id: 'cart-icon-bubble-secondary-sidebar',
          section: 'secondary-sidebar',
          selector: '.cart-icon-bubble-count'
        },
        {
          id: 'cart-icon-bubble-main-sidebar',
          section: 'main-sidebar',
          selector: '.cart-icon-bubble-count'
        }
      ];
    } else {
      arraySections = [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner'
        },
        {
          id: 'cart-icon-bubble-menu-drawer',
          section: 'menu-drawer',
          selector: '.cart-icon-bubble-count'
        },
        {
          id: 'cart-icon-bubble-mobile-header',
          section: 'mobile-header',
          selector: '.cart-icon-bubble-count'
        }
      ];
    }
    return arraySections
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class GiftWrapManager {
  constructor() {
    this.containerSelector = '[data-gift-wrap]';
    this.checkboxSelector = '.cart-gift-wrap__checkbox';
    this.activeRequest = null;

    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    this.handleCartUpdated = this.handleCartUpdated.bind(this);

    this.init();
    document.addEventListener('cart:updated', this.handleCartUpdated);
    document.addEventListener('shopify:section:load', this.handleCartUpdated);
    document.addEventListener('shopify:section:select', this.handleCartUpdated);
  }

  init() {
    const containers = document.querySelectorAll(this.containerSelector);
    containers.forEach((container) => {
      const checkbox = container.querySelector(this.checkboxSelector);
      if (!checkbox) return;
      if (checkbox.dataset.giftWrapInitialized === 'true') return;
      checkbox.dataset.giftWrapInitialized = 'true';
      checkbox.addEventListener('change', this.onCheckboxChange);
      checkbox.addEventListener('click', GiftWrapManager.stopPropagation, true);
    });
  }

  static stopPropagation(event) {
    event.stopPropagation();
  }

  handleCartUpdated() {
    requestAnimationFrame(() => this.init());
  }

  async onCheckboxChange(event) {
    event.stopImmediatePropagation();
    event.stopPropagation();
    const checkbox = event.currentTarget;
    const container = checkbox.closest(this.containerSelector);
    if (!container || this.activeRequest) {
      return;
    }

    // Toggle gift note field visibility
    const section = container.dataset.section;
    const giftNoteFieldId = section === 'cart-drawer' ? 'DrawerGiftNoteField' : 'GiftNoteField';
    const giftNoteField = document.getElementById(giftNoteFieldId);
    if (giftNoteField) {
      giftNoteField.style.display = checkbox.checked ? 'block' : 'none';
    }

    let variantId = container.dataset.variantId;

    if (!variantId) {
      const productId = container.dataset.productId;
      if (productId) {
        try {
          const product = await this.getProductById(productId);
          if (product && product.variants && product.variants.length > 0) {
            variantId = product.variants[0].id;
            container.dataset.variantId = variantId;
            if (product.variants[0].price) {
              container.dataset.price = product.variants[0].price;
              const priceElement = container.querySelector('.cart-gift-wrap__price');
              if (priceElement) {
                const currencyEnabled = container.dataset.currencyCodeEnabled === 'true';
                const price = product.variants[0].price / 100;
                if (currencyEnabled && window.Shopify && window.Shopify.currency) {
                  priceElement.textContent = new Intl.NumberFormat(document.documentElement.lang || 'es', {
                    style: 'currency',
                    currency: window.Shopify.currency.active || 'EUR'
                  }).format(price);
                } else {
                  priceElement.textContent = new Intl.NumberFormat(document.documentElement.lang || 'es', {
                    style: 'currency',
                    currency: 'EUR'
                  }).format(price);
                }
              }
            }
          } else {
            this.showError('Producto no encontrado');
            return;
          }
        } catch (error) {
          console.error(error);
          this.showError('Error al obtener el producto');
          return;
        }
      } else {
        return;
      }
    }

    checkbox.disabled = true;
    container.classList.add('is-loading');

    const lineKey = container.dataset.lineKey;
    const action = checkbox.checked ? this.addGiftWrap(variantId) : this.removeGiftWrap(variantId, lineKey);

    this.activeRequest = action
      .catch((error) => {
        console.error(error);
        checkbox.checked = !checkbox.checked;
        // Revert gift note field visibility on error
        if (giftNoteField) {
          giftNoteField.style.display = checkbox.checked ? 'block' : 'none';
        }
        this.showError(error && error.description ? error.description : (error && error.message ? error.message : window.cartStrings && window.cartStrings.error));
      })
      .finally(() => {
        this.activeRequest = null;
        if (document.body.contains(checkbox)) {
          checkbox.disabled = false;
        }
        if (document.body.contains(container)) {
          container.classList.remove('is-loading');
        }
      });
  }

  async getProductById(productId) {
    try {
      const response = await fetch(`/cart.js`);
      if (!response.ok) {
        throw new Error('Error al obtener el carrito');
      }
      const cart = await response.json();
      const product = cart.items.find(item => item.product_id === Number(productId));
      if (product) {
        return {
          id: product.product_id,
          variants: [{
            id: product.variant_id,
            price: product.price
          }]
        };
      }
      throw new Error('Producto no encontrado en el carrito. Por favor, añade el producto primero o usa el handle del producto.');
    } catch (error) {
      throw error;
    }
  }

  addGiftWrap(variantId) {
    return this.updateCart('add', variantId);
  }

  removeGiftWrap(variantId, lineKey) {
    return this.updateCart('remove', variantId, lineKey);
  }

  updateCart(action, variantId, lineKey) {
    const sections = this.collectSections();
    const sectionHandles = sections.map((section) => section.section || section.id);

    let payload;
    let endpoint;

    if (action === 'add') {
      payload = { items: [{ id: Number(variantId), quantity: 1 }] };
      endpoint = routes.cart_add_url;
    } else if (lineKey) {
      payload = { id: lineKey, quantity: 0 };
      endpoint = routes.cart_change_url;
    } else {
      payload = { updates: {} };
      payload.updates[variantId] = 0;
      endpoint = routes.cart_update_url;
    }

    if (sectionHandles.length) {
      payload.sections = sectionHandles;
      payload.sections_url = window.location.pathname;
    }

    return fetch(`${endpoint}`, { ...fetchConfig('javascript'), body: JSON.stringify(payload) })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status && parsedState.status !== 200) {
          return Promise.reject(parsedState);
        }

        if (parsedState.sections) {
          this.renderSections(parsedState, sections);
        }

        this.dispatchUpdates(parsedState);
        return parsedState;
      })
      .catch((error) => {
        throw error;
      });
  }

  collectSections() {
    const sectionMap = new Map();
    const cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      cartItems.getSectionsToRender().forEach((section) => {
        sectionMap.set(`${section.id}-${section.section}`, section);
      });
    }
    const cartDrawerItems = document.querySelector('cart-drawer-items');
    if (cartDrawerItems && typeof cartDrawerItems.getSectionsToRender === 'function') {
      cartDrawerItems.getSectionsToRender().forEach((section) => {
        sectionMap.set(`${section.id}-${section.section}`, section);
      });
    }
    return Array.from(sectionMap.values());
  }

  renderSections(parsedState, sections) {
    const getSectionInnerHTML = (html, selector) => {
      const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return element ? element.innerHTML : null;
    };

    sections.forEach((section) => {
      const sectionId = section.section || section.id;
      if (!parsedState.sections[sectionId]) return;

      const elements = document.querySelectorAll(`#${section.id}`);
      if (!elements.length) return;

      const html = getSectionInnerHTML(parsedState.sections[sectionId], `#${section.id}`);
      if (html === null) return;

      elements.forEach((element) => {
        element.innerHTML = html;
      });
    });

    if (typeof parsedState.item_count !== 'undefined') {
      const cartItems = document.querySelector('cart-items');
      if (cartItems) {
        cartItems.classList.toggle('is-empty', parsedState.item_count === 0);
      }
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      if (cartDrawerWrapper) {
        cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
      }
      const cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) {
        cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      }
    }
  }

  dispatchUpdates(parsedState) {
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: {
        cart: parsedState
      }
    }));

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-wrap' });
    }
  }

  showError(message) {
    const fallback = window.cartStrings && window.cartStrings.error ? window.cartStrings.error : 'Something went wrong';
    const errorMessage = message || fallback;
    const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (errors) {
      errors.textContent = errorMessage;
      errors.style.marginTop = '16px';
    }
  }
}

if (!window.__giftWrapManagerInitialized) {
  window.__giftWrapManagerInitialized = true;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.theme = window.theme || {};
      window.theme.giftWrapManager = new GiftWrapManager();
    });
  } else {
    window.theme = window.theme || {};
    window.theme.giftWrapManager = new GiftWrapManager();
  }
}

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    this.setupCountries();

    this.errors = this.querySelector('#ShippingCalculatorErrors');
    this.success = this.querySelector('#ShippingCalculatorSuccess');
    this.zip = this.querySelector('#ShippingCalculatorZip');
    this.country = this.querySelector('#ShippingCalculatorCountry');
    this.province = this.querySelector('#ShippingCalculatorProvince');
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onSubmitHandler.bind(this));
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('ShippingCalculatorCountry', 'ShippingCalculatorProvince', {
        hideElement: 'ShippingCalculatorProvinceContainer'
      });
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();

    this.errors.classList.add('hidden');
    this.success.classList.add('hidden');
    this.zip.classList.remove('invalid');
    this.country.classList.remove('invalid');
    this.province.classList.remove('invalid');
    this.button.classList.add('loading');
    this.button.setAttribute('disabled', true);
    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value
      }
    });
    let sectionUrl = `${routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.success.classList.remove('hidden');
          this.success.innerHTML = '';

          parsedState.shipping_rates.forEach((rate) => {
            const child = document.createElement('p');
            child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
            this.success.appendChild(child);
          });
        }
        else {
          let errors = [];
          Object.entries(parsedState).forEach(([attribute, messages]) => {
            errors.push(messages[0]);
          });

          this.errors.classList.remove('hidden');
          this.errors.querySelector('.errors').innerHTML = errors.join('; ');
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
        if (this.closest('.accordion__panel')) {
          this.closest('.accordion__panel').style.maxHeight = this.closest('.accordion__content').offsetHeight + 'px'
        }
      });
  }
}

customElements.define('shipping-calculator', ShippingCalculator);